import angular from 'angular'
import VendNumber, { round } from 'vend-number'
import ngRedux from 'ng-redux'
import { ApiStoreCredit } from '@vend/types'
import template from '../../../templates/customer/wr-customer-store-credit-balance.html'
import { CustomerBalancesManager } from '../../managers/customer-balances-manager'
import { selectSaleCustomer } from '../../state/slices/currentSale/currentSaleSlice'

/**
 * Directive for displaying a customer's store credit balance.
 *
 * @module webregister.directives.wrCustomerStoreCreditBalance
 */
angular
  .module('webregister.directives')
  .directive('wrCustomerStoreCreditBalance', WrCustomerStoreCreditBalance)

interface WrCustomerStoreCreditBalanceDirective {
  storeCredit: ApiStoreCredit
  determineStoreCreditBalance: () => string
}

function WrCustomerStoreCreditBalance() {
  return {
    scope: {
      storeCredit: '=',
    },
    restrict: 'E',
    template,
    bindToController: true,
    controllerAs: 'customerStoreCreditBalanceCtrl',

    /**
     * =======================================
     * STORE CREDIT BALANCE CONTROLLER
     * =======================================
     */
    controller(
      this: WrCustomerStoreCreditBalanceDirective,
      $ngRedux: ngRedux.INgRedux,
      customerBalancesManager: CustomerBalancesManager
    ) {
      /**
       * Used to determine what store credit value to return
       * @note When no sale is present we return just the customer's store credit,
       * when a sale is present we return the customer's store credit with added partial payments
       *
       * @method determineStoreCreditBalance
       */
      this.determineStoreCreditBalance = function () {
        const currentSaleCustomer = selectSaleCustomer($ngRedux.getState())

        let creditBalance = 0

        if (this.storeCredit) {
          creditBalance = this.storeCredit.balance
        }

        // If we have a sale with a customer and the customer balances have been initiated on the current sale
        // then return the calculated store credit balance
        if (currentSaleCustomer && this.storeCredit) {
          creditBalance = customerBalancesManager.calculateStoreCreditBalance()
        }

        return round(creditBalance, 2, VendNumber.ROUNDING_MODES.ROUND_DOWN)
      }
    },
  }
}
